var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPortfolioDefensiveConservative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 225,
    viewBox: "0 0 225 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8585_752)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 225,
    height: 225,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 112.5,
    r: 112.5,
    fill: "#80E49F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.5 0C133.248 2.47412e-07 153.591 5.73744 171.281 16.578C188.971 27.4185 203.319 42.9399 212.738 61.4261C222.157 79.9122 226.281 100.643 224.653 121.327C223.025 142.01 215.709 161.841 203.514 178.626L112.5 112.5L112.5 0Z",
    fill: "#1D873E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8585_752"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 225,
    height: 225,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPortfolioDefensiveConservative);
export default __webpack_public_path__ + "static/media/icon--portfolio--defensive-conservative.edb5ffbe3a9f9cdb9145f3064d564d0f.svg";
export { ForwardRef as ReactComponent };